module.exports = __webpack_public_path__ + "img/moveout-3.df960a03.jpg";